import { useCallback, useEffect, useMemo, useRef } from 'react';

import { useBetSlice } from '../../../store/slices/bets/selectors';
import { CoreLobbyMessageController } from '../../CoreLobbyMessageController';

import { IUpdateBalanceMessagePayload, updateBalanceMessage } from './updateBalanceMessage';

export const useUpdatedBalancePayload = (): IUpdateBalanceMessagePayload | null => {
  const balance = useBetSlice.getCompositeBalance();
  const totalBet = useBetSlice.totalBet();

  return useMemo(() => {
    if (balance) {
      return {
        amount: balance.amount,
        bonus: balance.bonus,
        totalBet,
      };
    }
    return null;
  }, [balance, totalBet]);
};

export const useUpdateBalanceMessageCallbackConnected = (): (() => void) => {
  const payload = useUpdatedBalancePayload();
  const payloadRef = useRef<IUpdateBalanceMessagePayload | null>(null);

  useEffect(() => {
    payloadRef.current = payload;
  }, [payload]);

  return useCallback(() => {
    if (payloadRef.current) {
      CoreLobbyMessageController.post(updateBalanceMessage(payloadRef.current));
    }
  }, []);
};
